import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitMonthlyActivityLogic } from './hooks/useNonprofitMonthlyActivityLogic';
import { NonprofitMonthlyActivityForm } from './NonprofitMonthlyActivityForm';

export const EddNonprofitMonthlyActivity = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitMonthlyActivityLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.nonprofitMonthlyActivity.title')}
        headingContainerCustomStyle='!mb-[16px]'>
        <NonprofitMonthlyActivityForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
